/**
 * CR460: Hook to fetch adapter recommendations for a given Merchant Source.
 * Reads from v_image_capture_adapter_recommendations.
 */
import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface AdapterRecommendation {
  recommended_adapter_key: string;
  adapter_display_name: string;
  score: number;
  reasons: string[] | null;
  adapter_enabled: boolean;
  current_adapter_key: string | null;
  rec_rank: number;
}

export function useAdapterRecommendations(merchantSourceId: string | null) {
  const [recommendations, setRecommendations] = useState<AdapterRecommendation[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!merchantSourceId) {
      setRecommendations([]);
      return;
    }
    setLoading(true);
    const { data, error } = await (supabase as any)
      .from("v_image_capture_adapter_recommendations")
      .select(
        "recommended_adapter_key, adapter_display_name, score, reasons, adapter_enabled, current_adapter_key, rec_rank"
      )
      .eq("merchant_source_id", merchantSourceId)
      .order("rec_rank", { ascending: true });
    if (!error && data) {
      setRecommendations(data as AdapterRecommendation[]);
    }
    setLoading(false);
  }, [merchantSourceId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { recommendations, loading, refetch: fetch };
}
